/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Muscles_MetaInputs */

const en_us2_progress_report_muscles_meta = /** @type {(inputs: Progress_Report_Muscles_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`This week, against the plan's target`);
	return /** @type {LocalizedString} */ (`Weekly average, against the plan's target`)
	
};

const pt_br2_progress_report_muscles_meta = /** @type {(inputs: Progress_Report_Muscles_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Na semana, contra a meta do plano`);
	return /** @type {LocalizedString} */ (`Média por semana, contra a meta do plano`)
	
};

const es_419_progress_report_muscles_meta = /** @type {(inputs: Progress_Report_Muscles_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Esta semana, frente a la meta del plan`);
	return /** @type {LocalizedString} */ (`Promedio semanal, frente a la meta del plan`)
	
};

const pt_pt2_progress_report_muscles_meta = /** @type {(inputs: Progress_Report_Muscles_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Na semana, face à meta do plano`);
	return /** @type {LocalizedString} */ (`Média por semana, face à meta do plano`)
	
};

const fr_fr2_progress_report_muscles_meta = /** @type {(inputs: Progress_Report_Muscles_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Cette semaine, par rapport à l'objectif du programme`);
	return /** @type {LocalizedString} */ (`Moyenne par semaine, par rapport à l'objectif du programme`)
	
};

const de_de2_progress_report_muscles_meta = /** @type {(inputs: Progress_Report_Muscles_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Diese Woche, im Vergleich zum Planziel`);
	return /** @type {LocalizedString} */ (`Wochenschnitt, im Vergleich zum Planziel`)
	
};

const it_it2_progress_report_muscles_meta = /** @type {(inputs: Progress_Report_Muscles_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Questa settimana, rispetto all'obiettivo della scheda`);
	return /** @type {LocalizedString} */ (`Media settimanale, rispetto all'obiettivo della scheda`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "This week, against the plan's target" |
* | * | "Weekly average, against the plan's target" |
*
* @param {Progress_Report_Muscles_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_muscles_meta = /** @type {((inputs: Progress_Report_Muscles_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Muscles_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_muscles_meta(inputs)
	if (locale === "es-419") return es_419_progress_report_muscles_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_muscles_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_muscles_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_report_muscles_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_report_muscles_meta(inputs)
	return en_us2_progress_report_muscles_meta(inputs)
});
export { progress_report_muscles_meta as "progress-report.muscles_meta" }